import {
    validationDefault,
    validationDefaultNew,
    maxModeloVehiculo,
} from '../../components/utilities/rulesUtilities';
import genericOptions from '../defaultConfigRole/genericOptions';
import genericColumnsCalculator from '../defaultConfigRole/genericColumnsCalculator';
import requestsListStatus from './requestsListStatus';
import { randomFloat } from '../../components/utilities/functions/General';
import { PROPERTIES, URL } from '../../constants/constantValues';

const Rules = {
    role_68a5cff3f9ba418e8892737ac387d234: {
        //Cartera
        home: 'credits',
        requestsListStatus,
        views: {
            create: {
                titleRequestCredit: 'Solicitudes de créditos',
                permisions: ['listRequestCredit'],
                components: [
                    { name: 'Documentos', component: ['DocumentsCreditView'] },
                    {
                        name: 'Solicitante',
                        component: ['InformationClient', 'FilterAutomatics'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    {
                        name: 'Inf. negocio',
                        component: ['BusinessInformationCredit'],
                    },
                    {
                        name: 'Codeudores',
                        component: ['ConyugeClient', 'CodebtorCredit'],
                    },
                    {
                        name: 'Información de la solicitud',
                        component: [
                            'ApprovalCertificate',
                            // 'InformationCredit',
                            // 'CalculatorCredit',
                        ],
                    },
                    {
                        name: 'Garantías Mobiliarias',
                        component: ['Guarantees'],
                    },
                    {
                        name: 'Información de desembolso',
                        component: ['MedioDePago'],
                    },
                    { name: 'Seguros', component: ['InsuresCredit'] },

                    {
                        name: 'Documentos',
                        component: ['DocumentsCredit'],
                    },
                ],
                actionStatus: [
                    'devolver',
                    'retornar',
                    'resumen',
                    'anotaciones',
                    'desistir',
                ],
                actionStatusAll: ['resumen', 'anotaciones'],
                groupUser: 6,
                //notEditForm: true,
            },
            consult: {
                permisions: [
                    'consultClientList',
                    'consultExceptionDocuments',
                    'ConsultClientEdit',
                    'InformationCredit:edit',
                ],
                components: [
                    {
                        name: 'Solicitante',
                        component: ['InformationClient'],
                    },
                    { name: 'Contacto', component: ['ContactsClient'] },
                    { name: 'Documentos', component: ['DocumentsClient'] },
                    {
                        name: 'Solicitudes cliente',
                        component: ['RequestsClient'],
                    },
                    { name: 'Crédito', component: ['GygClient'] },
                ],
                noShowFieldsConsult: true,
            },
            profile: {
                fields: [
                    {
                        name: 'identification_number',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],
                            'número de identificación'
                        ),
                    },
                    {
                        name: 'first_name',
                        label: 'Nombres',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'nombres'
                        ),
                    },
                    {
                        name: 'last_name',
                        label: 'Apellidos',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'apellidos'
                        ),
                    },
                    {
                        name: 'phone_number',
                        label: 'Número telefónico',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'número telefónico'
                        ),
                    },
                ],
            },
        },
        components: {
            informationClient: {
                permisions: [
                    'informationClient:list',
                    'informationClient:edit',
                ],

                automaticFilters: true,
                fields: [
                    {
                        name: 'tipo_identificacion',
                        testid: 'ClientTypeIdInput',
                        label: 'Tipo identificación',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        label: 'Número de identificación',
                        name: 'numero_identificacion',
                        testid: 'ClientIdInput',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],

                            'numero de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        testid: 'ClientFirstNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        testid: 'ClientSecondNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        testid: 'ClientLastFirsNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        testid: 'ClientSecondFirsNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'genero',
                        testid: 'ClientGenderInput',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        testid: 'ClientDocumentPlaceInput',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        testid: 'ClientDocumentDateInput',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                    },
                    {
                        name: 'lugar_nacimiento',
                        testid: 'ClientBirthPlaceInput',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                    },
                    {
                        name: 'fecha_nacimiento',
                        testid: 'ClientBirthDateInput',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                    },
                    {
                        label: 'Peso (Kg)',
                        name: 'peso',
                        testid: 'ClientWeightInput',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        label: 'Estatura (en cms)',
                        name: 'estatura',
                        testid: 'ClientHeightInput',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'grupo_social',
                        testid: 'ClientSocialGroupInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.grupo_etnico,
                    },
                    {
                        name: 'peps',
                        testid: 'ClientPepsInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.direccion_principal,
                    },
                ],
            },
            socioeconomicClient: {
                permisions: [
                    'socioeconomicClient:list',
                    'socioeconomicClient:edit',
                ],

                fields: [
                    {
                        name: 'estado_civil',
                        disabled: true,
                        type: 'select',
                        col: 2,
                        options: genericOptions.estado_civil,
                    },
                    {
                        name: 'tipo_vivienda',
                        disabled: true,
                        type: 'select',
                        col: 2,
                        options: genericOptions.tipo_vivienda,
                        validation: validationDefaultNew(
                            [{ type: 'required', value: true }],
                            'tipo vivienda'
                        ),
                    },
                    {
                        name: 'estrato',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                { type: 'max', value: PROPERTIES.STRATUM.max },
                                { type: 'min', value: PROPERTIES.STRATUM.min },
                            ],

                            'estrato'
                        ),
                    },
                    {
                        name: 'ciiu',
                        label: 'Actividad económica',
                        disabled: true,
                        type: 'autocomplete',
                        col: 2,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                    },
                    {
                        name: 'descripcion_actividad_economica',
                        label: 'Descripción actividad económica',
                        disabled: true,
                        type: 'string',
                        col: 4,
                    },
                    {
                        label: 'Antigüedad residencia (meses)',
                        name: 'antiguedad_residencia',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.ANTIQUITY.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.ANTIQUITY.min,
                                },
                            ],

                            'antigüedad residencia'
                        ),
                    },
                    {
                        name: 'tamano_hogar',
                        label: 'Integrantes del hogar',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.HOUSEHOLD_MEMBERS.min,
                                },
                            ],

                            'Integrantes del hogar'
                        ),
                    },
                    {
                        name: 'personas_a_cargo',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.PEOPLE_IN_CHARGE.min,
                                },
                            ],

                            'personas a cargo'
                        ),
                    },
                    {
                        name: 'numero_hijos',
                        label: 'Número hijos',
                        disabled: true,
                        type: 'integer',
                        col: 2,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'max',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.max,
                                },
                                {
                                    type: 'min',
                                    value: PROPERTIES.NUMBER_OF_CHILDREN.min,
                                },
                            ],

                            'número de hijos'
                        ),
                    },
                    {
                        name: 'escolaridad',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.escolaridad,
                    },
                    {
                        name: 'naturaleza',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        options: [
                            {
                                value: 'I',
                                label: 'Independiente',
                                fields: [
                                    {
                                        name: 'tipo_de_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE.required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .BUSINESS_TYPE
                                                        .minLength,
                                                },
                                            ],

                                            'tipo de negocio'
                                        ),
                                    },
                                    {
                                        name: 'nombre_negocio',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.JOB_NAME
                                                        .minLength,
                                                },
                                            ],

                                            'nombre negocio'
                                        ),
                                    },
                                    {
                                        name: 'experiencia',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .required,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.EXPERIENCE
                                                        .minLength,
                                                },
                                            ],

                                            'experiencia'
                                        ),
                                    },
                                    {
                                        name: 'antiguedad',
                                        label: 'Antigüedad',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES.ANTIQUITY
                                                        .min,
                                                },
                                            ],

                                            'antigüedad'
                                        ),
                                    },
                                    {
                                        name: 'actividad',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES.ACTIVITY
                                                        .minLength,
                                                },
                                            ],

                                            'actividad'
                                        ),
                                    },
                                    {
                                        label: 'Descripción',
                                        name: 'descripcion',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .DESCRIPTION.minLength,
                                                },
                                            ],

                                            'descripción'
                                        ),
                                    },
                                    {
                                        name: 'ingresos_aproximados',
                                        disabled: false,
                                        type: 'integer',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'segundo apellido'
                                        ),
                                    },
                                    {
                                        name: 'sector_economico',
                                        label: 'Sector económico',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: true,
                                                },
                                                {
                                                    type: 'maxLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .maxLength,
                                                },
                                                {
                                                    type: 'minLength',
                                                    value: PROPERTIES
                                                        .ECONOMIC_SECTOR
                                                        .minLength,
                                                },
                                            ],

                                            'sector económico'
                                        ),
                                    },
                                    {
                                        name: 'numero_de_empleados_permanentes',
                                        label: 'Número de empleados permanentes',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .PERMANENT_EMPLOYES.min,
                                                },
                                            ],

                                            'número de empleados permanentes'
                                        ),
                                    },
                                    {
                                        name: 'numero_de_empleados_temporales',
                                        label: 'Número de empleados temporales',
                                        disabled: false,
                                        type: 'integer',
                                        col: 3,
                                        validation: validationDefaultNew(
                                            [
                                                {
                                                    type: 'required',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES
                                                        .required,
                                                },
                                                {
                                                    type: 'max',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.max,
                                                },
                                                {
                                                    type: 'min',
                                                    value: PROPERTIES
                                                        .TEMPORARY_EMPLOYES.min,
                                                },
                                            ],

                                            'número de empleados temporales'
                                        ),
                                    },
                                    {
                                        name: 'tipo_local',
                                        disabled: false,
                                        type: 'string',
                                        col: 2,
                                        validation: validationDefaultNew(
                                            [{ type: 'required', value: true }],
                                            'tipo de local'
                                        ),
                                    },
                                ],
                            },
                        ],

                        isMulti: false,
                    },
                ],
            },
            contactsClient: {
                permisions: [
                    'contactsClient:list',
                    'contactsClient:edit',
                    'contactsClient:editButton',
                    'contactsClient:editButtonConsult',
                ],

                tittle: 'solicitante',
                fields: [
                    {
                        name: 'ciudad_contacto',
                        testid: 'ContactCityInput',
                        label: 'Ciudad',
                        disabled: false,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_contacto',
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'ciudad de contacto'
                        ),
                    },
                    {
                        name: 'barrio_contacto',
                        testid: 'ContactNeighborhoodInput',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_contacto',
                        options: [],
                        url: URL.BARRIOS.value,
                        validation: validationDefault(
                            ['required'],
                            'barrio de contacto'
                        ),
                    },
                    {
                        name: 'direccion',
                        testid: 'ContactAddressInput',
                        label: 'Dirección',
                        disabled: false,
                        type: 'addressComplement',
                        staticCol: 12,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ADDRESS.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ADDRESS.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ADDRESS.minLength,
                                },
                            ],

                            'dirección'
                        ),
                    },
                    {
                        name: 'referencia_ubicacion',
                        testid: 'ContactUbicationInput',
                        label: 'Referencia ubicación',
                        disabled: false,
                        type: 'string',
                        col: 6,
                        showTable: true,
                    },
                    {
                        name: 'telefono',
                        testid: 'ContactPhoneInput',
                        label: 'Teléfono',
                        disabled: false,
                        type: 'phone',
                        col: 6,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                            ],

                            'teléfono'
                        ),
                    },
                    {
                        name: 'celular',
                        testid: 'ContactCellphoneInput',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],

                            'celular'
                        ),
                    },
                    {
                        name: 'correo_electronico',
                        testid: 'ContactEmailInput',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                                {
                                    type: 'required',
                                    value: true,
                                },
                            ],

                            'correo electrónico'
                        ),
                    },
                    {
                        name: 'principal',
                        testid: 'ContactPrincipalInput',
                        label: 'Principal',
                        disabled: false,
                        type: 'select',
                        options: genericOptions.direccion_principal,
                        col: 6,
                        showTable: true,
                    },
                ],

                defaultValues: {
                    direccion: 'carrera 1 calle 1 # 1',
                    barrio: 'Ciudad modelo',
                    latitud: '11111324',
                    longitud: '38947239',
                    telefono: '',
                    celular: '',
                    correo_electronico: 'test@finamiga.co',
                    referencia_ubicacion: 'cerca a... diagonal a...',
                    tipo_ubicacion: 1,
                    departamento: 5,
                    ciudad_contacto: 1205,
                },
            },
            informationCredit: {
                permisions: [
                    'informationCredit:list',
                    'informationCredit:edit',
                ],

                fields: [
                    {
                        name: 'subproducto',
                        testid: 'SubproductInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                    },
                    {
                        name: 'oficina',
                        testid: 'OfficeInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'ejecutivo',
                        url: URL.OFICINAS.value,
                        validation: validationDefault(['required'], 'oficina'),
                    },
                    {
                        name: 'ejecutivo',
                        testid: 'ExecutiveInput',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        dependency: 'oficinas',
                        url: URL.EJECUTIVOS.value,
                        notSearchGlobals: true,
                        validation: validationDefault(
                            ['required'],
                            'ejecutivo'
                        ),
                    },
                    {
                        name: 'origen',
                        testid: 'originInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.ORIGEN.value,
                        validation: validationDefault(['required'], 'origen'),
                    },
                    {
                        name: 'medio',
                        testid: 'mediumInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.MEDIO.value,
                        validation: validationDefault(['required'], 'medio'),
                    },
                    {
                        name: 'tipo_credito',
                        testid: 'CreditTypeInput',
                        label: 'Tipo crédito',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_credito,
                        validation: validationDefault(
                            ['required'],
                            'tipo de crédito'
                        ),
                    },

                    {
                        name: 'seguro_voluntario',
                        testid: 'VoluntaryInsureInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                    },
                    {
                        name: 'seguro_protegidos',
                        testid: 'ProtectedInsuranceInput',
                        label: 'Seguro PROTEGI2',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: true,
                    //     type: 'select',
                    //     col: 3,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
                inputsFinalRequest: [
                    {
                        product: [2, 41, 42, 43, 119, 47],
                        fields: [
                            'modelo_vehiculo',
                            'chasis_vehiculo',
                            'motor_vehiculo',
                            'color_vehiculo',
                            'placa_vehiculo',
                            'codigo_fasecolda',
                        ],
                    },
                    {
                        product: [3, 6, 8, 10, 18, 12, 14, 120],
                        fields: ['destino_recursos'],
                    },
                    {
                        product: [17, 113, 114, 40],
                        fields: [
                            'modelo_vehiculo',
                            'chasis_vehiculo',
                            'motor_vehiculo',
                            'color_vehiculo',
                            'placa_vehiculo',
                            'codigo_fasecolda',
                            'clase_vehiculo',
                            'tipo_servicio_vehiculo',
                            'carroceria',
                        ],
                    },
                ],

                defaultValues: {
                    oficina: 9,
                    producto: 17,
                    origen: 1,
                    medio: 1,
                    tipo_credito: 1,
                    monto_solicitado: 5000000,
                    plazo_solicitado: 2,
                    cuota_inicial_solicitada: 1500000,
                    asesor: 'asesor test',
                    telefono_asesor: '123456798',
                    concesionario: 'concesionario test',
                    marca: 'Bajaj',
                    linea: 'Pulsar',
                    valor: 8000000,
                    soat: 480000,
                    impuestos: 120000,
                    matricula: 200000,
                    nombre_concesionario: 'concesionario test!',
                    tipo_motocicleta: 'motocicleta',
                },
            },
            productCredit: {
                permisions: ['productCredit:list', 'productCredit:edit'],
                fields: [],
                filedsConditional: {
                    p2: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            testid: 'ConcessionaireHomologatedAddressInput',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p3: [
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p8: [
                        // Prestamiga Preferencial
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p10: [
                        // Prestamiga Renovacion
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p18: [
                        // Prestamiga Reactivacion
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],

                    p6: [
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p12: [
                        // Cultiva renovacion
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p14: [
                        // Cultiva preferencial
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p17: [
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            // options: genericOptions.tipo_servicio,
                            url: '/globals/tipo_servicio_vehiculo/',
                            // defaultValue: {
                            //     label: 'PUBLICO',
                            //     value: 0,
                            // },
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p40: [
                        // Vehiculos usados
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },

                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            disabled: true,
                            type: 'integer',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    { type: 'required', value: true },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: maxModeloVehiculo(),
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo servicio'
                            ),
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipos de carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'valor_fasecolda',
                            testid: 'FasecoldaValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p41: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p42: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p43: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p47: [
                        // Vehiculos renovacion
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p113: [
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p114: [
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            testid: 'MachineryValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p115: [
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p117: [
                        // CARGA_ESPECIALES_2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            testid: 'MachineryValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p118: [
                        // carga pasajeros 2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p119: [
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            testid: 'ConcessionaireHomologatedAddressInput',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],

                    p120: [
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p131: [
                        // MOTO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            testid: 'ConcessionaireHomologatedAddressInput',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p132: [
                        // PROGRESA RECONSTRUYE
                        // Prestamiga
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 4,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            allSubChildrenDependencies: [
                                'aliado_concesionario',
                            ],

                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 4,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p133: [
                        // CAMPO RECONSTRUYE
                        // Cultiva
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            parentDependency: true,
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p134: [
                        // CARGA RECONSTRUYE
                        // Vehiculos
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            // options: genericOptions.tipo_servicio,
                            url: '/globals/tipo_servicio_vehiculo/',
                            // defaultValue: {
                            //     label: 'PUBLICO',
                            //     value: 0,
                            // },
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p135: [
                        // MOTOCARRO RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p136: [
                        // PROGRESA COMPROMISO VALLE RECONSTRUYE
                        // Prestamiga_compromiso_valle
                        {
                            name: 'destino_recursos',
                            testid: 'DestinationResourcesInput',
                            disabled: true,
                            type: 'string',
                            col: 4,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .minLength,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.DESTINATION_RESOURCES
                                            .maxLength,
                                    },
                                ],

                                'destino de los recursos'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 4,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 4,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                    ],
                    p137: [
                        // CARGA 2.0 RECONSTRUYE
                        // Carga2.0
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p138: [
                        // CARGA ESPECIALES RECONSTRUYE
                        // CARGA_ESPECIALES
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'valor_maquinaria',
                            testid: 'MachineryValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor maquinaria'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },

                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p139: [
                        // CARGA PASAJEROS RECONSTRUYE
                        // carga pasajeros
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            allSubChildrenDependencies: [
                                'analista_financiero_concesionario',
                            ],

                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'linea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo de vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo de vehículo'
                            ),
                        },
                        {
                            name: 'seguro_todo_riesgo_vehiculo',
                            testid: 'RiskInsuranceInput',
                            label: 'Seguro todo riesgo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=1',
                            validation: validationDefault(
                                ['required'],
                                'Seguro todo riesgo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matricula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'serie_vehiculo',
                            testid: 'ProductVehicleSeriesInput',
                            label: 'Serie vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_SERIE
                                            .minLength,
                                    },
                                ],

                                'Serie vehículo'
                            ),
                        },
                        {
                            name: 'clase_vehiculo',
                            testid: 'ProductVehicleClassInput',
                            label: 'Clase vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CLASES_VEHICULOS.value,
                        },
                        {
                            name: 'tipo_servicio_vehiculo',
                            testid: 'ProductVehicleServiceTypeInput',
                            label: 'Tipo servicio',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_servicio_vehiculo/',
                        },
                        {
                            name: 'carroceria',
                            testid: 'ProductBodyworkInput',
                            label: 'Tipo carrocería',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.CARROCERIAS.value,
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'analista_financiero_concesionario',
                            testid: 'AnalistaFinancieroConcesionarioInput',
                            label: 'Analista financiero',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/analistas_financieros/',
                            dependency: 'concesionario',
                            notSearchGlobals: true,
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'tipo_conductor_vehiculo',
                            testid: 'VehicleDriverTypeInput',
                            label: 'Tipo conductor del vehículo',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            url: '/globals/tipo_conductor_externo_vehiculo/',
                            validation: validationDefault(
                                ['required'],
                                'Tipo conductor del vehículo'
                            ),
                        },
                        {
                            name: 'subrogacion',
                            testid: 'SubrogationInput',
                            label: 'Subrogación',
                            disabled: true,
                            type: 'switch',
                            typeColumn: 2,
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'subrogacion'
                            ),
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                    p130: [
                        // MOTO COMPROMISO VALLE RECONSTRUYE
                        {
                            name: 'concesionario_ciudad',
                            testid: 'ConcessionaireCityInput',
                            label: 'Ciudad concesionario',
                            disabled: true,
                            type: 'autocomplete-dependency',
                            col: 3,
                            options: [],
                            showTable: true,
                            parentDependency: true,
                            childrenDependency: 'concesionario',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad concesionario'
                            ),
                        },
                        {
                            name: 'concesionario',
                            testid: 'ConcessionaireInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'concesionario_ciudad',
                            trueDependency: 'ciudad',
                            url: URL.CONCESIONARIOS.value,
                            childrenDependency: 'aliado_concesionario',
                            validation: validationDefault(
                                ['required'],
                                'concesionario'
                            ),
                        },
                        {
                            name: 'concesionario_direccion_homologada',
                            testid: 'ConcessionaireHomologatedAddressInput',
                            label: 'Concesionario dirección',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'marca',
                            testid: 'BrandInput',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            parentDependency: true,
                            dependency: 'producto',
                            childrenDependency: 'linea',
                            url: URL.MARCAS.value,
                            validation: validationDefault(
                                ['required'],
                                'marca'
                            ),
                        },
                        {
                            name: 'linea',
                            testid: 'LineInput',
                            label: 'Línea',
                            disabled: false,
                            type: 'select',
                            col: 3,
                            dependency: 'marca',
                            url: URL.LINEA.value,
                            validation: validationDefault(
                                ['required'],
                                'línea'
                            ),
                        },
                        {
                            name: 'tipo_vehiculo',
                            testid: 'TypeInput',
                            label: 'Tipo vehículo',
                            disabled: true,
                            type: 'select',
                            dependency: 'subproducto',
                            trueDependency: 'subproductos',
                            col: 3,
                            url: URL.TIPO_VEHICULOS_POR_SUBPRODUCTO.value,
                            validation: validationDefault(
                                ['required'],
                                'tipo vehículo'
                            ),
                        },
                        {
                            name: 'valor',
                            testid: 'ValueInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'valor'
                            ),
                        },
                        {
                            name: 'soat',
                            testid: 'SoatInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(['required'], 'soat'),
                        },
                        {
                            name: 'impuestos',
                            testid: 'TaxInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'impuestos'
                            ),
                        },
                        {
                            name: 'matricula',
                            testid: 'RegistrationInput',
                            label: 'Matrícula',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'matrícula'
                            ),
                        },
                        {
                            name: 'cuota_inicial_solicitada',
                            testid: 'PaymentInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'cuota inicial solicitada'
                            ),
                        },
                        {
                            name: 'monto_solicitado',
                            testid: 'AmountInput',
                            disabled: true,
                            type: 'price',
                            col: 3,
                            validation: validationDefault(
                                ['required'],
                                'monto solicitado'
                            ),
                        },
                        {
                            name: 'plazo_solicitado',
                            testid: 'TermInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            url: URL.PLAZOS_SOLICITADO.value,
                            validation: validationDefault(
                                ['required'],
                                'plazo solicitado'
                            ),
                        },
                        {
                            name: 'placa_vehiculo',
                            testid: 'ProductVehiclePlateInput',
                            label: 'Placa vehículo',
                            type: 'stringLink',
                            iconLink: 'iconsminds-magnifi-glass',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_PLATE
                                            .minLength,
                                    },
                                ],

                                'placa'
                            ),
                        },
                        {
                            name: 'modelo_vehiculo',
                            testid: 'VehicleModelInput',
                            label: 'Modelo vehículo',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_MODEL
                                            .minLength,
                                    },
                                    {
                                        type: 'max',
                                        value: PROPERTIES.VEHICLE_MODEL.max,
                                    },
                                    {
                                        type: 'min',
                                        value: PROPERTIES.VEHICLE_MODEL.min,
                                    },
                                ],

                                'modelo'
                            ),
                        },
                        {
                            name: 'chasis_vehiculo',
                            testid: 'ProductVehicleChassisInput',
                            label: 'Chasis vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_CHASSIS
                                            .minLength,
                                    },
                                ],

                                'chasis'
                            ),
                        },
                        {
                            name: 'motor_vehiculo',
                            testid: 'ProductVehicleMotorInput',
                            label: 'Motor vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_ENGINE
                                            .minLength,
                                    },
                                ],

                                'motor'
                            ),
                        },
                        {
                            name: 'color_vehiculo',
                            testid: 'ProductVehicleColorInput',
                            label: 'Color vehículo',
                            type: 'string',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.VEHICLE_COLOR
                                            .minLength,
                                    },
                                ],

                                'color'
                            ),
                        },
                        {
                            name: 'codigo_fasecolda',
                            testid: 'ProductFasecoldaCodeInput',
                            label: 'Código fasecolda',
                            type: 'integer',
                            disabled: false,
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.FASECOLDA.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.FASECOLDA.minLength,
                                    },
                                ],

                                'código fasecolda'
                            ),
                        },
                        {
                            name: 'aliado_concesionario',
                            testid: 'AllyInput',
                            label: 'Aliado',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            url: URL.ALIADOS.value,
                            dependency: 'concesionario',
                            trueDependency: 'concesionarios',
                            notSearchGlobals: true,
                            validation: validationDefault(
                                ['required'],
                                'Aliado'
                            ),
                        },
                        {
                            name: 'numero_aliado',
                            testid: 'AllyNumberInput',
                            label: 'Número aliado',
                            disabled: true,
                            type: 'string',
                            col: 3,
                        },
                        {
                            name: 'seguro_agro',
                            testid: 'AgroInsureInput',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            dependency: 'subproducto',
                            clear: true,
                            url: '/globals/categoria_tipo_seguro_solicitud/?solicitud_tipo_seguro=5',
                        },
                    ],
                },
            },
            documentsCredit: {
                generateDocuments: true,
                permisions: ['documentsCredit:list', 'documentsCredit:edit'],
                fields: [
                    {
                        name: 'solicitud_tipo_documento',
                        //label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/solicitudes/tipo_documentos/?roles=6&productos={0}&is_active=true',
                        reduxParams: ['credit.subproducto.producto'],
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                        testid: 'DocumentTypeInput',
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                        testid: 'DocumentFileInput',
                    },
                ],
            },
            documentsDisbursement: {
                permisions: ['documentsDisbursement:list'],
                fields: [
                    {
                        name: 'solicitud_tipo_documento',
                        label: 'Tipo documento',
                        disabled: false,
                        type: 'select',
                        col: 5,
                        url: '/solicitudes/tipo_documentos/?roles=6&productos={0}&is_active=true',
                        reduxParams: ['credit.producto'],
                        shouldSendRequestConstantly: true,
                        showTable: true,
                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'documento',
                        disabled: false,
                        type: 'file',
                        col: 5,
                        validation: validationDefault(
                            ['required'],
                            'documento'
                        ),
                    },
                ],
            },
            observationCredit: {
                permisions: [
                    'observationCredit:list',
                    'observationCredit:edit',
                ],

                fields: [
                    {
                        className: 'input-observacion',
                        name: 'observacion',
                        label: 'Observación',
                        disabled: false,
                        type: 'string',
                        rows: 1,
                        typeColumn: 2,
                        col: 12,
                        showTable: true,
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'observación'
                        ),
                    },
                ],
            },
            calculatorCredit: {
                permisions: [
                    'calculatorCredit:list',
                    'calculatorCredit:edit',
                    'calculatorCredit:simulator',
                    'calculatorCredit:notCalculate',
                ],

                summaryCredit: genericColumnsCalculator.summaryCredit,
                monthlyValues: genericColumnsCalculator.monthlyValues,
                defaultValues: {},
                fields: [
                    {
                        name: 'subproducto',
                        testid: 'SubproductInput',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: [],
                        parentDependency: true,
                        url: URL.SUBPRODUCTO.value,
                        validation: validationDefault(
                            ['required'],
                            'subproducto'
                        ),
                    },
                    {
                        name: 'seguro_voluntario',
                        testid: 'VoluntaryInsureInput',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.seguro_voluntario,
                        defaultValue: {
                            value: '0',
                            label: 'SIN SEGURO',
                        },
                        validation: validationDefault(
                            ['required'],
                            'seguro voluntario'
                        ),
                    },
                    {
                        name: 'seguro_protegidos',
                        testid: 'ProtectedInsuranceInput',
                        label: 'Seguro PROTEGI2',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        clear: true,
                        url: URL.SEGURO_FAMILIA.value,
                        dependency: 'subproducto',
                    },
                    // {
                    //     label: 'Seguro SBS',
                    //     name: 'tipo_seguro',
                    //     disabled: false,
                    //     type: 'select',
                    //     col: 4,
                    //     options: genericOptions.tipo_seguro_sbs,
                    //     validation: validationDefault(
                    //         ['required'],
                    //         'seguro sbs'
                    //     ),
                    // },
                ],
            },
            conyugeClient: {
                permisions: ['conyugeClient:list'],
                disabledButtonSave: false,
                fields: [
                    {
                        name: 'Información básica',
                        desc: '',
                        fields: [
                            {
                                name: 'primer_nombre',
                                testid: 'ConyugeClientFirstNameInput',
                                disabled: true,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_NAME
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_NAME
                                                .minLength,
                                        },
                                    ],

                                    'primer nombre'
                                ),
                            },
                            {
                                name: 'segundo_nombre',
                                testid: 'ConyugeClientSecondNameInput',
                                disabled: true,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .minLength,
                                        },
                                    ],

                                    'segundo nombre'
                                ),
                            },
                            {
                                name: 'primer_apellido',
                                testid: 'ConyugeClientLastFirsNameInput',
                                disabled: true,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.FIRST_SURNAME
                                                .minLength,
                                        },
                                    ],

                                    'primer apellido'
                                ),
                            },
                            {
                                name: 'segundo_apellido',
                                testid: 'ConyugeClientSecondFirsNameInput',
                                disabled: true,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.SECOND_SURNAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.SECOND_NAME
                                                .minLength,
                                        },
                                    ],

                                    'segundo apellido'
                                ),
                            },
                            {
                                name: 'genero',
                                testid: 'ConyugeClientGenderInput',
                                label: 'Género',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.genero,
                                validation: validationDefault(
                                    ['required'],
                                    'genero'
                                ),
                            },
                            {
                                name: 'tipo_identificacion',
                                testid: 'ConyugeClientIdTypeInput',
                                label: 'Tipo identificación',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_de_documento,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo de documento'
                                ),
                            },
                            {
                                name: 'numero_identificacion',
                                testid: 'ConyugeClientIdNumberInput',
                                label: 'Numero de identificación',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ID_NUMBER
                                                .required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ID_NUMBER
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ID_NUMBER
                                                .minLength,
                                        },
                                    ],

                                    'numero de identificación'
                                ),
                            },
                            {
                                name: 'lugar_nacimiento',
                                testid: 'ConyugeClientBirthPlaceInput',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.CIUDADES.value,
                                validation: validationDefault(
                                    ['required'],
                                    'lugar de nacimiento'
                                ),
                            },
                            {
                                name: 'fecha_nacimiento',
                                testid: 'ConyugeClientBirthDateInput',
                                disabled: true,
                                type: 'date',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'fecha de nacimiento'
                                ),
                            },
                            {
                                name: 'tipo_relacion',
                                testid: 'ConyugeClientRelationTypeInput',
                                label: 'Tipo relación',
                                disabled: true,
                                type: 'hidden',
                                col: 3,
                                value: 0,
                            },
                            {
                                name: 'estado_civil',
                                testid: 'ConyugeClientCivilStatusInput',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'Información de contacto',
                        desc: '',
                        fields: [
                            {
                                name: 'ciudad_contacto',
                                testid: 'ConyugeClientContactCityInput',
                                label: 'Ciudad',
                                disabled: true,
                                type: 'autocomplete-dependency',
                                col: 6,
                                showTable: true,
                                options: [],
                                parentDependency: true,
                                childrenDependency: 'barrio_contacto',
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'barrio_contacto',
                                testid: 'ConyugeClientContactNeighborhoodInput',
                                disabled: true,
                                type: 'select',
                                col: 6,
                                showTable: true,
                                dependency: 'ciudad_contacto',
                                options: [],
                                url: URL.BARRIOS.value,
                            },
                            {
                                name: 'direccion',
                                testid: 'ConyugeClientAddressInput',
                                label: 'Dirección',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                            },
                            {
                                name: 'referencia_ubicacion',
                                testid: 'ConyugeClientLocationReferenceInput',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'telefono',
                                testid: 'ConyugeClientPhoneInput',
                                label: 'Teléfono',
                                disabled: true,
                                type: 'phone',
                                col: 6,
                            },
                            {
                                name: 'celular',
                                testid: 'ConyugeClientCellphoneInput',
                                label: 'Celular',
                                disabled: false,
                                type: 'celular',
                                col: 6,
                                showTable: true,
                            },
                            {
                                name: 'correo_electronico',
                                testid: 'ConyugeClientEmailInput',
                                label: 'Correo electrónico',
                                disabled: false,
                                type: 'email',
                                col: 6,
                                showTable: true,
                            },
                        ],
                    },
                    {
                        name: 'Información del trabajo',
                        desc: '',
                        fields: [
                            {
                                name: 'trabajo_nombre',
                                testid: 'ConyugeClientJobNameInput',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.JOB_NAME
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.JOB_NAME
                                                .minLength,
                                        },
                                    ],

                                    'empresa'
                                ),
                            },
                            {
                                name: 'trabajo_antiguedad',
                                testid: 'ConyugeClientJobAntiquityInput',
                                label: 'Antigüedad (meses)',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'extra_telefono',
                                testid: 'ConyugeClientExtraPhoneInput',
                                label: 'Teléfono de la empresa',
                                disabled: true,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'empresa_salario',
                                testid: 'ConyugeClientCompanySalaryInput',
                                label: 'Ingresos',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                            {
                                name: 'negocio_actividad',
                                testid: 'ConyugeClientBusinessActivityInput',
                                label: 'Actividad económica',
                                disabled: true,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'trabajo_ciudad',
                                testid: 'ConyugeClientJobCityInput',
                                label: 'Ciudad de trabajo',
                                disabled: true,
                                type: 'autocomplete',
                                col: 6,
                                options: [],
                                url: URL.CIUDADES.value,
                            },
                            {
                                name: 'trabajo_direccion',
                                testid: 'ConyugeClientJobAddressInput',
                                label: 'Dirección del trabajo',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'trabajo_referencia_ubicacion',
                                testid: 'ConyugeClientJobLocationReferenceInput',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                            },
                        ],
                    },
                ],

                defaultValues: {
                    tipo_de_documento: 'CC',
                    numero_identificacion: '123455556',
                    primer_nombre: 'test 1',
                    segundo_nombre: 'test 2',
                    primer_apellido: 'test ape1',
                    segundo_apellido: 'test ape2',
                    genero: 'H',
                    lugar_expedicion_documento: 1205,
                    fecha_expedicion_documento: '2020-08-30',
                    lugar_nacimiento: 1205,
                    fecha_nacimiento: '2020-08-30',
                    telefono_celular: '3105436525',
                    telefono_fijo: '5555555',

                    //info-trabajo
                    empresa: 'pruebas',
                    direccion_trabajo: 'vereda  aaaa',
                    codigo_postal: '76001',
                    descripcion_actividad_economica: 'test information',
                    antiguedad: 1,
                    telefono_empresa: '3215647',
                    ingresos: '200000',
                    actividad_economica: 'Venta de jugos',
                },
            },
            codebtorCredit: {
                permission: ['codebtorCredit:list'],
                fields: [],
            },
            codebtorInformation: {
                tittle: 'codeudor',
                fields: [
                    {
                        name: 'tipo_identificacion',
                        testid: 'CodebtorInformationIdTypeInput',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_de_documento,
                        validation: validationDefault(
                            ['required'],
                            'tipo identificación'
                        ),
                    },
                    {
                        name: 'numero_identificacion',
                        testid: 'CodebtorInformationIdNumberInput',
                        label: 'Número identificación',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],

                            'número de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        testid: 'CodebtorInformationFirstNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        testid: 'CodebtorInformationSecondNameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        testid: 'CodebtorInformationFirstSurnameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        testid: 'CodebtorInformationSecondSurnameInput',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'genero',
                        testid: 'CodebtorInformationGenderInput',
                        label: 'Género',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.genero,
                        validation: validationDefault(['required'], 'genero'),
                    },
                    {
                        name: 'lugar_expedicion_documento',
                        testid: 'CodebtorInformationDocumentPlaceInput',
                        label: 'Lugar expedición documento',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de expedición documento'
                        ),
                    },
                    {
                        name: 'fecha_expedicion_documento',
                        testid: 'CodebtorInformationDocumentDateInput',
                        label: 'Fecha expedición documento',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de expedición del documento'
                        ),
                    },
                    {
                        name: 'lugar_nacimiento',
                        testid: 'CodebtorInformationBirthPlaceInput',
                        disabled: false,
                        type: 'autocomplete',
                        col: 3,
                        options: [],
                        url: URL.CIUDADES.value,
                        validation: validationDefault(
                            ['required'],
                            'lugar de nacimiento'
                        ),
                    },
                    {
                        name: 'fecha_nacimiento',
                        testid: 'CodebtorInformationBirthDateInput',
                        disabled: false,
                        type: 'date',
                        col: 3,
                        validation: validationDefault(
                            ['required'],
                            'fecha de nacimiento'
                        ),
                    },
                    {
                        name: 'tipo_relacion',
                        testid: 'CodebtorRelationshipInput',
                        label: 'Tipo relación',
                        disabled: true,
                        type: 'hidden',
                        col: 3,
                        value: 1,
                    },
                ],

                socioEconomicCodebtor: {
                    fields: [
                        {
                            name: 'naturaleza_persona',
                            testid: 'CodebtorInformationPersonNatureInput',
                            label: 'Tipo',
                            disabled: true,
                            type: 'select',
                            col: 3,
                            options: genericOptions.tipo_codeudor,
                            validation: validationDefault(
                                ['required'],
                                'naturaleza'
                            ),
                            isMulti: false,
                        },
                    ],

                    fieldsConditional: {
                        pI: [
                            {
                                name: 'estado_civil',
                                testid: 'CodebtorInformationCivilStatusInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                            },
                            {
                                name: 'tipo_vivienda',
                                testid: 'CodebtorInformationHousingTypeInput',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                            },
                            {
                                name: 'estrato',
                                testid: 'CodebtorInformationStratumInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'estrato'
                                ),
                            },
                            {
                                name: 'personas_a_cargo',
                                testid: 'CodebtorInformationPeopleInChargeInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                            },
                            {
                                name: 'numero_hijos',
                                testid: 'CodebtorInformationChildrenNumberInput',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,

                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                            },
                            {
                                name: 'escolaridad',
                                testid: 'CodebtorInformationSchoolingInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                testid: 'CodebtorInformationJobNameInput',
                                label: 'Nombre del negocio',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'trabajo_telefono',
                                testid: 'CodebtorInformationJobPhoneInput',
                                label: 'Teléfono del negocio',
                                disabled: true,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono del negocio'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                testid: 'CodebtorInformationJobCellphoneInput',
                                label: 'Celular',
                                disabled: true,
                                type: 'celular',
                                col: 3,
                            },
                            {
                                name: 'negocio_liquidez',
                                testid: 'CodebtorInformationBusinessLiquidityInput',
                                label: 'Liquidez',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                            {
                                name: 'trabajo_antiguedad',
                                testid: 'CodebtorInformationJobAntiquityInput',
                                label: 'Antigüedad  (meses)',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'negocio_actividad',
                                testid: 'CodebtorInformationBusinessActivityInput',
                                label: 'Actividad económica',
                                disabled: true,
                                type: 'autocomplete',
                                col: 3,
                                options: [],
                                url: URL.ACTIVIDAD_ECONOMICA.value,
                            },
                            {
                                name: 'negocio_descripcion',
                                testid: 'CodebtorInformationBusinessDescriptionInput',
                                label: 'Descripción actividad económica',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'trabajo_direccion',
                                testid: 'CodebtorInformationJobAddressInput',
                                label: 'Dirección del negocio',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'referencia_ubicacion',
                                testid: 'CodebtorInformationLocationReferenceInput',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                        ],

                        pE: [
                            // EMPLEADO
                            {
                                name: 'estado_civil',
                                testid: 'CodebtorInformationCivilStatusInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                            },
                            {
                                name: 'tipo_vivienda',
                                testid: 'CodebtorInformationHousingTypeInput',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                            },
                            {
                                name: 'estrato',
                                testid: 'CodebtorInformationStratumInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'estrato'
                                ),
                            },
                            {
                                name: 'personas_a_cargo',
                                testid: 'CodebtorInformationPeopleInChargeInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                            },
                            {
                                name: 'numero_hijos',
                                testid: 'CodebtorInformationChildrenNumberInput',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,

                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                            },
                            {
                                name: 'escolaridad',
                                testid: 'CodebtorInformationSchoolingInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                testid: 'CodebtorInformationJobNameInput',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'empresa_contrato',
                                testid: 'CodebtorInformationCompanyContractInput',
                                label: 'Contrato',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                            },
                            {
                                name: 'trabajo_cargo',
                                testid: 'CodebtorInformationJobPositionInput',
                                label: 'Cargo',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'empresa_salario',
                                testid: 'CodebtorInformationCompanySalaryInput',
                                label: 'Salario',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                            {
                                name: 'trabajo_antiguedad',
                                testid: 'CodebtorInformationJobAntiquityInput',
                                label: 'Antigüedad empresa (meses)',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'trabajo_direccion',
                                testid: 'CodebtorInformationJobAddressInput',
                                label: 'Dirección empresa',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'referencia_ubicacion',
                                testid: 'CodebtorInformationLocationReferenceInput',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'trabajo_telefono',
                                testid: 'CodebtorInformationJobPhoneInput',
                                label: 'Teléfono empresa',
                                disabled: true,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                testid: 'CodebtorInformationJobCellphoneInput',
                                label: 'Celular',
                                disabled: true,
                                type: 'celular',
                                col: 3,
                            },
                        ],

                        pP: [
                            // PENSIONADO
                            {
                                name: 'estado_civil',
                                testid: 'CodebtorInformationCivilStatusInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                            },
                            {
                                name: 'tipo_vivienda',
                                testid: 'CodebtorInformationHousingTypeInput',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                            },
                            {
                                name: 'estrato',
                                testid: 'CodebtorInformationStratumInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'estrato'
                                ),
                            },
                            {
                                name: 'personas_a_cargo',
                                testid: 'CodebtorInformationPeopleInChargeInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                            },
                            {
                                name: 'numero_hijos',
                                testid: 'CodebtorInformationChildrenNumberInput',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,

                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                            },
                            {
                                name: 'escolaridad',
                                testid: 'CodebtorInformationSchoolingInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                            },
                            {
                                name: 'trabajo_nombre',
                                testid: 'CodebtorInformationJobNameInput',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'empresa_contrato',
                                testid: 'CodebtorInformationCompanyContractInput',
                                label: 'Contrato',
                                disabled: true,
                                type: 'select',
                                col: 3,
                                options: genericOptions.tipo_contrato_codeudor,
                            },
                            {
                                name: 'trabajo_cargo',
                                testid: 'CodebtorInformationJobPositionInput',
                                label: 'Cargo',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'empresa_salario',
                                testid: 'CodebtorInformationCompanySalaryInput',
                                label: 'Salario',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                            {
                                name: 'trabajo_direccion',
                                testid: 'CodebtorInformationJobAddressInput',
                                label: 'Dirección empresa',
                                disabled: true,
                                type: 'addressComplement',
                                staticCol: 12,
                            },
                            {
                                name: 'referencia_ubicacion',
                                testid: 'CodebtorInformationLocationReferenceInput',
                                label: 'Referencia ubicación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'trabajo_telefono',
                                testid: 'CodebtorInformationJobPhoneInput',
                                label: 'Teléfono empresa',
                                disabled: true,
                                type: 'phone',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'pattern',
                                            value: PROPERTIES.PHONE.regExp,
                                            mesagge:
                                                'El número ingresado no es un número válido',
                                        },
                                    ],

                                    'teléfono de la empresa'
                                ),
                            },
                            {
                                name: 'trabajo_celular',
                                testid: 'CodebtorInformationJobCellphoneInput',
                                label: 'Celular',
                                disabled: true,
                                type: 'celular',
                                col: 3,
                            },
                            {
                                name: 'trabajo_antiguedad',
                                testid: 'CodebtorInformationJobAntiquityInput',
                                label: 'Antigüedad empresa (meses)',
                                disabled: true,
                                type: 'integer',
                                col: 3,
                            },
                        ],

                        pFR: [
                            // FINCA RAIZ
                            {
                                name: 'estado_civil',
                                testid: 'CodebtorInformationCivilStatusInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                                validation: validationDefault(
                                    ['required'],
                                    'estado civil'
                                ),
                            },
                            {
                                name: 'tipo_vivienda',
                                testid: 'CodebtorInformationHousingTypeInput',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.tipo_vivienda,
                                validation: validationDefaultNew(
                                    [{ type: 'required', value: true }],
                                    'tipo vivienda'
                                ),
                            },
                            {
                                name: 'estrato',
                                testid: 'CodebtorInformationStratumInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefault(
                                    ['required'],
                                    'estrato'
                                ),
                            },
                            {
                                name: 'personas_a_cargo',
                                testid: 'CodebtorInformationPeopleInChargeInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.PEOPLE_IN_CHARGE
                                                .min,
                                        },
                                    ],

                                    'personas a cargo'
                                ),
                            },
                            {
                                name: 'numero_hijos',
                                testid: 'CodebtorInformationChildrenNumberInput',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,

                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'max',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .max,
                                        },
                                        {
                                            type: 'min',
                                            value: PROPERTIES.NUMBER_OF_CHILDREN
                                                .min,
                                        },
                                    ],

                                    'número de hijos'
                                ),
                            },
                            {
                                name: 'escolaridad',
                                testid: 'CodebtorInformationSchoolingInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                                validation: validationDefault(
                                    ['required'],
                                    'escolaridad'
                                ),
                            },
                            {
                                name: 'trabajo_cargo',
                                testid: 'CodebtorInformationJobPositionInput',
                                label: 'Ocupación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'trabajo_nombre',
                                testid: 'CodebtorInformationJobNameInput',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'empresa_salario',
                                testid: 'CodebtorInformationCompanySalaryInput',
                                label: 'Salario',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                        ],

                        pFS: [
                            // FIRMA SOLIDARIA
                            {
                                name: 'estado_civil',
                                testid: 'CodebtorInformationCivilStatusInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.estado_civil,
                            },
                            {
                                name: 'tipo_vivienda',
                                testid: 'CodebtorInformationHousingTypeInput',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                options: genericOptions.tipo_vivienda,
                            },
                            {
                                name: 'estrato',
                                testid: 'CodebtorInformationStratumInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'personas_a_cargo',
                                testid: 'CodebtorInformationPeopleInChargeInput',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'numero_hijos',
                                testid: 'CodebtorInformationChildrenNumberInput',
                                label: 'Número hijos',
                                disabled: false,
                                type: 'integer',
                                col: 3,
                            },
                            {
                                name: 'escolaridad',
                                testid: 'CodebtorInformationSchoolingInput',
                                disabled: false,
                                type: 'select',
                                col: 3,
                                options: genericOptions.escolaridad,
                            },
                            {
                                name: 'trabajo_cargo',
                                testid: 'CodebtorInformationJobPositionInput',
                                label: 'Ocupación',
                                disabled: true,
                                type: 'string',
                                col: 6,
                            },
                            {
                                name: 'trabajo_nombre',
                                testid: 'CodebtorInformationJobNameInput',
                                label: 'Empresa',
                                disabled: true,
                                type: 'string',
                                col: 3,
                            },
                            {
                                name: 'empresa_salario',
                                testid: 'CodebtorInformationCompanySalaryInput',
                                label: 'Salario',
                                disabled: true,
                                type: 'price',
                                col: 3,
                            },
                        ],
                    },
                },
                contactCodebtor: {
                    fields: [
                        {
                            name: 'ciudad_contacto',
                            testid: 'CodebtorInformationContactCityInput',
                            label: 'Ciudad',
                            disabled: false,
                            type: 'autocomplete-dependency',
                            col: 6,
                            showTable: true,
                            options: [],
                            parentDependency: true,
                            childrenDependency: 'barrio_contacto',
                            url: URL.CIUDADES.value,
                            validation: validationDefault(
                                ['required'],
                                'ciudad de contacto'
                            ),
                        },
                        {
                            name: 'barrio_contacto',
                            testid: 'CodebtorInformationContactNeighborhoodInput',
                            disabled: false,
                            type: 'select',
                            col: 6,
                            showTable: true,
                            dependency: 'ciudad_contacto',
                            options: [],
                            url: URL.BARRIOS.value,
                            validation: validationDefault(
                                ['required'],
                                'barrio de contacto'
                            ),
                        },
                        {
                            name: 'direccion',
                            testid: 'CodebtorInformationAddressInput',
                            label: 'Dirección',
                            disabled: false,
                            type: 'addressComplement',
                            staticCol: 12,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'required',
                                        value: PROPERTIES.ADDRESS.required,
                                    },
                                    {
                                        type: 'maxLength',
                                        value: PROPERTIES.ADDRESS.maxLength,
                                    },
                                    {
                                        type: 'minLength',
                                        value: PROPERTIES.ADDRESS.minLength,
                                    },
                                ],

                                'dirección'
                            ),
                        },
                        {
                            name: 'referencia_ubicacion',
                            testid: 'CodebtorInformationLocationReferenceInput',
                            label: 'Referencia ubicación',
                            disabled: false,
                            type: 'string',
                            col: 6,
                            showTable: true,
                        },
                        {
                            name: 'telefono',
                            testid: 'CodebtorInformationPhoneInput',
                            label: 'Teléfono',
                            disabled: false,
                            type: 'phone',
                            col: 3,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                ],

                                'teléfono'
                            ),
                        },
                        {
                            name: 'celular',
                            testid: 'CodebtorInformationCellphoneInput',
                            label: 'Celular',
                            disabled: false,
                            type: 'celular',
                            col: 3,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.CELL_PHONE.regExp,
                                        mesagge:
                                            'El número ingresado no es un número válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.CELL_PHONE.required,
                                    },
                                ],

                                'celular'
                            ),
                        },
                        {
                            name: 'correo_electronico',
                            testid: 'CodebtorInformationEmailInput',
                            label: 'Correo electrónico',
                            disabled: false,
                            type: 'email',
                            col: 6,
                            showTable: true,
                            validation: validationDefaultNew(
                                [
                                    {
                                        type: 'pattern',
                                        value: PROPERTIES.EMAIL.regExp,
                                        mesagge:
                                            'El correo electrónico ingresado no es válido',
                                    },
                                    {
                                        type: 'required',
                                        value: PROPERTIES.EMAIL.required,
                                    },
                                ],

                                'correo electrónico'
                            ),
                        },
                        {
                            name: 'principal',
                            testid: 'CodebtorInformationPrincipalInput',
                            label: 'Principal',
                            disabled: false,
                            type: 'select',
                            options: genericOptions.direccion_principal,
                            col: 6,
                            showTable: true,
                        },
                    ],
                },
                codebtorConyuge: {
                    fields: [
                        {
                            name: 'Información básica',
                            desc: '',
                            fields: [
                                {
                                    name: 'tipo_identificacion',
                                    testid: 'CodebtorInformationIdTypeInput',
                                    label: 'Tipo identificación',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.tipo_de_documento,
                                    validation: validationDefault(
                                        ['required'],
                                        'tipo identificación'
                                    ),
                                },
                                {
                                    name: 'numero_identificacion',
                                    testid: 'CodebtorInformationIdNumberInput',
                                    label: 'Número identificación',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ID_NUMBER
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ID_NUMBER
                                                    .minLength,
                                            },
                                        ],

                                        'número de identificación'
                                    ),
                                },
                                {
                                    name: 'primer_nombre',
                                    testid: 'CodebtorInformationFirstNameInput',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_NAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'primer nombre'
                                    ),
                                },
                                {
                                    name: 'segundo_nombre',
                                    testid: 'CodebtorInformationSecondNameInput',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'segundo nombre'
                                    ),
                                },
                                {
                                    name: 'primer_apellido',
                                    testid: 'CodebtorInformationFirstSurnameInput',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.FIRST_SURNAME
                                                    .minLength,
                                            },
                                        ],

                                        'primer apellido'
                                    ),
                                },
                                {
                                    name: 'segundo_apellido',
                                    testid: 'CodebtorInformationSecondSurnameInput',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.SECOND_SURNAME
                                                    .minLength,
                                            },
                                        ],

                                        'segundo nombre'
                                    ),
                                },
                                {
                                    name: 'genero',
                                    testid: 'CodebtorInformationGenderInput',
                                    label: 'Género',
                                    disabled: false,
                                    type: 'select',
                                    col: 3,
                                    options: genericOptions.genero,
                                    validation: validationDefault(
                                        ['required'],
                                        'genero'
                                    ),
                                },
                                {
                                    name: 'lugar_nacimiento',
                                    testid: 'CodebtorInformationBirthPlaceInput',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 3,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'lugar de nacimiento'
                                    ),
                                },
                                {
                                    name: 'fecha_nacimiento',
                                    testid: 'CodebtorInformationBirthDateInput',
                                    disabled: false,
                                    type: 'date',
                                    col: 3,
                                    validation: validationDefault(
                                        ['required'],
                                        'fecha de nacimiento'
                                    ),
                                },
                                {
                                    name: 'tipo_relacion',
                                    testid: 'CodebtorRelationshipInput',
                                    label: 'Tipo relación',
                                    disabled: false,
                                    type: 'hidden',
                                    col: 3,
                                    value: 2,
                                },
                            ],

                            defaultValues: {
                                tipo_de_documento: 'CC',
                                numero_identificacion: Math.floor(
                                    randomFloat(0, 1) * 10000
                                ),
                                primer_nombre: 'test 1',
                                segundo_nombre: 'test 2',
                                primer_apellido: 'test ape1',
                                segundo_apellido: 'test ape2',
                                genero: 'H',
                                lugar_expedicion_documento: 1205,
                                fecha_expedicion_documento: '2020-08-30',
                                lugar_nacimiento: 1205,
                                fecha_nacimiento: '2020-08-30',
                                telefono: '3102344556',
                                //info-trabajo
                                estado_civil: 'S',
                                estrato: 1,
                                ciuu: 10,
                                descripcion_actividad_economica:
                                    'test information',
                                antiguedad_residencia: 1,
                                personas_a_cargo: 1,
                                numero_hijos: 1,
                                escolaridad: 'PO',
                                naturaleza: 'I',
                            },
                        },
                        {
                            name: 'Información de contacto',
                            desc: '',
                            fields: [
                                {
                                    name: 'ciudad_contacto',
                                    testid: 'CodebtorInformationContactCityInput',
                                    label: 'Ciudad',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    col: 6,
                                    showTable: true,
                                    options: [],
                                    parentDependency: true,
                                    childrenDependency: 'barrio_contacto',
                                    url: URL.CIUDADES.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'ciudad de contacto'
                                    ),
                                },
                                {
                                    name: 'barrio_contacto',
                                    testid: 'CodebtorInformationContactNeighborhoodInput',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    showTable: true,
                                    dependency: 'ciudad_contacto',
                                    options: [],
                                    url: URL.BARRIOS.value,
                                    validation: validationDefault(
                                        ['required'],
                                        'barrio de contacto'
                                    ),
                                },
                                {
                                    name: 'direccion',
                                    testid: 'CodebtorInformationAddressInput',
                                    label: 'Dirección',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'required',
                                                value: PROPERTIES.ADDRESS
                                                    .required,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.ADDRESS
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.ADDRESS
                                                    .minLength,
                                            },
                                        ],

                                        'dirección'
                                    ),
                                },
                                {
                                    name: 'referencia_ubicacion',
                                    testid: 'CodebtorInformationLocationReferenceInput',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    showTable: true,
                                },
                                {
                                    name: 'telefono',
                                    testid: 'CodebtorInformationPhoneInput',
                                    label: 'Teléfono',
                                    disabled: false,
                                    type: 'phone',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],

                                        'teléfono'
                                    ),
                                },
                                {
                                    name: 'celular',
                                    testid: 'CodebtorInformationCellphoneInput',
                                    label: 'Celular',
                                    disabled: false,
                                    type: 'celular',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.CELL_PHONE
                                                    .regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.CELL_PHONE
                                                    .required,
                                            },
                                        ],

                                        'celular'
                                    ),
                                },
                                {
                                    name: 'correo_electronico',
                                    testid: 'CodebtorInformationEmailInput',
                                    label: 'Correo electrónico',
                                    disabled: false,
                                    type: 'email',
                                    col: 6,
                                    showTable: true,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.EMAIL.regExp,
                                                mesagge:
                                                    'El correo electrónico ingresado no es válido',
                                            },
                                            {
                                                type: 'required',
                                                value: PROPERTIES.EMAIL
                                                    .required,
                                            },
                                        ],

                                        'correo electrónico'
                                    ),
                                },
                            ],
                        },
                        {
                            name: 'Información del trabajo',
                            desc: '',
                            fields: [
                                {
                                    name: 'trabajo_nombre',
                                    testid: 'CodebtorInformationJobNameInput',
                                    label: 'Empresa',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.JOB_NAME
                                                    .minLength,
                                            },
                                        ],

                                        'empresa'
                                    ),
                                },
                                {
                                    name: 'trabajo_antiguedad',
                                    testid: 'CodebtorInformationJobAntiquityInput',
                                    label: 'Antigüedad (meses)',
                                    disabled: false,
                                    type: 'integer',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'max',
                                                value: PROPERTIES.ANTIQUITY.max,
                                            },
                                            {
                                                type: 'min',
                                                value: PROPERTIES.ANTIQUITY.min,
                                            },
                                        ],

                                        'antigüedad (meses)'
                                    ),
                                },
                                {
                                    name: 'extra_telefono',
                                    testid: 'CodebtorInformationExtraPhoneInput',
                                    label: 'Teléfono de la empresa',
                                    disabled: false,
                                    type: 'phone',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'pattern',
                                                value: PROPERTIES.PHONE.regExp,
                                                mesagge:
                                                    'El número ingresado no es un número válido',
                                            },
                                        ],

                                        'teléfono de la empresa'
                                    ),
                                },
                                {
                                    name: 'empresa_salario',
                                    testid: 'CodebtorInformationCompanySalaryInput',
                                    label: 'Ingresos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],

                                        'ingresos'
                                    ),
                                },
                                {
                                    name: 'otros_ingresos',
                                    testid: 'CodebtorInformationOtherIncomesInput',
                                    label: 'Otros ingresos',
                                    disabled: false,
                                    type: 'price',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES.INCOME
                                                    .maxLength,
                                            },
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES.INCOME
                                                    .minLength,
                                            },
                                        ],

                                        'Otros ingresos'
                                    ),
                                },
                                {
                                    name: 'descripcion_otros_ingresos',
                                    testid: 'CodebtorInformationOtherIncomesDescriptionInput',
                                    label: 'Descripción otros ingresos',
                                    disabled: false,
                                    type: 'string',
                                    col: 3,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES
                                                    .DESCRIPTION_ACTIVITY
                                                    .maxLength,
                                            },
                                        ],

                                        'descripción actividad económica'
                                    ),
                                },
                                {
                                    name: 'negocio_actividad',
                                    testid: 'CodebtorInformationBusinessActivityInput',
                                    label: 'Actividad económica',
                                    disabled: false,
                                    type: 'autocomplete',
                                    col: 6,
                                    options: [],
                                    url: URL.ACTIVIDAD_ECONOMICA.value,
                                },
                                {
                                    name: 'trabajo_ciudad',
                                    testid: 'CodebtorInformationJobCityInput',
                                    label: 'Ciudad de trabajo',
                                    disabled: false,
                                    type: 'autocomplete-dependency',
                                    parentDependency: true,
                                    childrenDependency: 'trabajo_barrio',
                                    col: 6,
                                    options: [],
                                    url: URL.CIUDADES.value,
                                },
                                {
                                    name: 'trabajo_barrio',
                                    testid: 'CodebtorInformationJobNeighborhoodInput',
                                    label: 'Barrio del trabajo',
                                    disabled: false,
                                    type: 'select',
                                    col: 6,
                                    dependency: 'trabajo_ciudad',
                                    trueDependency: 'ciudad',
                                    url: URL.BARRIOS.value,
                                },
                                {
                                    name: 'trabajo_direccion',
                                    testid: 'CodebtorInformationJobAddressInput',
                                    label: 'Dirección del trabajo',
                                    disabled: false,
                                    type: 'addressComplement',
                                    staticCol: 12,
                                },
                                {
                                    name: 'trabajo_referencia_ubicacion',
                                    testid: 'CodebtorInformationJobLocationReferenceInput',
                                    label: 'Referencia ubicación',
                                    disabled: false,
                                    type: 'string',
                                    col: 6,
                                    validation: validationDefaultNew(
                                        [
                                            {
                                                type: 'minLength',
                                                value: PROPERTIES
                                                    .BUSINESS_LOCATION_REFERENCE
                                                    .minLength,
                                            },
                                            {
                                                type: 'maxLength',
                                                value: PROPERTIES
                                                    .BUSINESS_LOCATION_REFERENCE
                                                    .maxLength,
                                            },
                                        ],

                                        'referencia ubicación'
                                    ),
                                },
                            ],
                        },
                    ],
                },
            },
            heritageCodebtor: {
                fields: [
                    {
                        name: 'Presupuesto familiar',
                        testid: 'HeritageCodebtorFamilyBudgetInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'ingreso_principal',
                                testid: 'HeritageCodebtorPrincipalIncomeInput',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'ingreso principal'
                                ),
                            },
                            {
                                name: 'ingreso_conyuge',
                                testid: 'HeritageCodebtorSpouseIncomeInput',
                                label: 'Ingresos cónyuge',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'Ingresos cónyuge'
                                ),
                            },
                            {
                                name: 'otros_ingresos',
                                testid: 'HeritageCodebtorOtherIncomesInput',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'otros ingresos'
                                ),
                            },
                            {
                                name: 'gastos_familiar',
                                testid: 'HeritageCodebtorFamilyExpensesInput',
                                label: 'Gasto familiar',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'gasto familiar'
                                ),
                            },
                            {
                                name: 'obligaciones',
                                testid: 'HeritageCodebtorObligationsInput',
                                label: 'Obligaciones / cuotas',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'obligaciones / cuotas'
                                ),
                            },
                            {
                                name: 'excedente',
                                testid: 'HeritageCodebtorSurplusInput',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'excedente'
                                ),
                            },
                        ],
                    },
                    {
                        name: 'Presupuesto empresarial',
                        testid: 'HeritageCodebtorBusinessBudgetInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'total_activos',
                                testid: 'HeritageCodebtorTotalAssetsInput',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total activos'
                                ),
                            },
                            {
                                name: 'total_pasivos',
                                testid: 'HeritageCodebtorTotalLiabilitiesInput',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total pasivo'
                                ),
                            },
                            {
                                name: 'total_patrimonio',
                                testid: 'HeritageCodebtorTotalEquityInput',
                                disabled: false,
                                type: 'price',
                                col: 4,
                                validation: validationDefault(
                                    ['required'],
                                    'total patrimonio'
                                ),
                            },
                        ],
                    },
                ],

                realState: [
                    {
                        name: 'Bienes raíces',
                        testid: 'HeritageCodebtorRealEstateInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'tipo_vivienda',
                                testid: 'HeritageCodebtorHousingTypeInput',
                                label: 'Tipo de bien raíz',
                                disabled: false,
                                type: 'select',
                                options: genericOptions.tipo_de_bien_raiz,
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'tipo de bien raíz'
                                ),
                            },
                            {
                                name: 'valor_bien_raiz',
                                testid: 'HeritageCodebtorRealEstateValueInput',
                                label: 'Valor comercial',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'valor comercial'
                                ),
                            },
                            {
                                name: 'direccion_bien_raiz',
                                testid: 'HeritageCodebtorRealEstateAddressInput',
                                label: 'Dirección',
                                disabled: false,
                                type: 'addressComplement',
                                staticCol: 12,
                                showTable: true,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'required',
                                            value: PROPERTIES.ADDRESS.required,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.ADDRESS.maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.ADDRESS.minLength,
                                        },
                                    ],

                                    'dirección'
                                ),
                            },
                            {
                                name: 'referencia_ubicacion',
                                testid: 'HeritageCodebtorLocationReferenceInput',
                                label: 'Referencia ubicación',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .minLength,
                                        },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES
                                                .BUSINESS_LOCATION_REFERENCE
                                                .maxLength,
                                        },
                                    ],

                                    'referencia ubicación'
                                ),
                            },
                        ],
                    },
                ],

                ownVehicle: [
                    {
                        name: 'Vehículo',
                        testid: 'HeritageCodebtorVehicleInput',
                        desc: '...',
                        fields: [
                            {
                                name: 'marca',
                                testid: 'HeritageCodebtorBrandInput',
                                disabled: false,
                                type: 'select',
                                col: 6,
                                url: URL.MARCAS.value,
                                validation: validationDefault(
                                    ['required'],
                                    'marca'
                                ),
                            },
                            {
                                name: 'placa',
                                testid: 'HeritageCodebtorPlateInput',
                                disabled: false,
                                type: 'string',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.VEHICLE_PLATE
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.VEHICLE_PLATE
                                                .minLength,
                                        },
                                        {
                                            type: 'pattern',
                                            value: /^[a-zA-Z0-9_.-]*$/,
                                            mesagge:
                                                'La placa solo debe tener numeros y letras',
                                        },
                                    ],

                                    'placa'
                                ),
                            },
                            {
                                name: 'modelo',
                                testid: 'HeritageCodebtorModelInput',
                                disabled: false,
                                type: 'integer',
                                col: 6,
                                validation: validationDefaultNew(
                                    [
                                        { type: 'required', value: true },
                                        {
                                            type: 'maxLength',
                                            value: PROPERTIES.VEHICLE_MODEL
                                                .maxLength,
                                        },
                                        {
                                            type: 'minLength',
                                            value: PROPERTIES.VEHICLE_MODEL
                                                .minLength,
                                        },
                                    ],

                                    'modelo'
                                ),
                            },
                            {
                                name: 'valor_vehiculo',
                                testid: 'HeritageCodebtorVehicleValueInput',
                                label: 'Valor comercial',
                                disabled: false,
                                type: 'price',
                                col: 6,
                                validation: validationDefault(
                                    ['required'],
                                    'valor comercial'
                                ),
                            },
                        ],
                    },
                ],
            },
            approvalCertificate: {
                permission: ['list:approvalCertificate'],
                disabledMesesPeriodo: true,
                fields: [
                    {
                        name: 'vinculo_agro',
                        testid: 'ApprovalCertificateAgroLinkInput',
                        label: 'Vínculo agro',
                        disabled: true,
                        type: 'select',
                        options: genericOptions.vinculo_agro,
                        col: 4,
                        validation: validationDefault(
                            ['required'],
                            'Vínculo agro'
                        ),
                    },
                    {
                        name: 'periodo_gracia',
                        testid: 'ApprovalCertificateGracePeriodInput',
                        disabled: true,
                        type: 'switch',
                        col: 3,
                        typeColumn: 2,
                        validation: validationDefault(
                            ['required'],
                            'periodo de gracia'
                        ),
                    },

                    {
                        name: 'meses_periodo',
                        testid: 'ApprovalCertificatePeriodMonthsInput',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.meses_de_gracia,
                    },
                    {
                        name: 'excepcion',
                        testid: 'ApprovalCertificateExceptionInput',
                        label: 'Excepción',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.TIPO_EXEPCIONES.value,
                    },
                    {
                        name: 'propuesta_inicial',
                        testid: 'ApprovalCertificateInitialProposalInput',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.propuesta_inicial,
                    },
                    {
                        name: 'codeudores',
                        testid: 'ApprovalCertificateCodebtorsInput',
                        disabled: true,
                        type: 'select-multiple',
                        col: 8,
                        url: URL.OFICINAS.value,
                        validation: validationDefault(
                            ['required'],
                            'codeudores'
                        ),
                    },
                    {
                        name: 'fecha_comite',
                        testid: 'ApprovalCertificateCommitteeDateInput',
                        label: 'Fecha comité',
                        disabled: true,
                        type: 'date',
                        col: 4,
                    },

                    {
                        name: 'comite',
                        testid: 'ApprovalCertificateCommitteeInput',
                        label: 'Comité',
                        disabled: true,
                        type: 'string',
                        col: 8,
                    },

                    {
                        name: 'recoge_saldo',
                        testid: 'ApprovalCertificateCollectBalanceInput',
                        disabled: true,
                        type: 'switch',
                        typeColumn: 2,
                        col: 4,
                        validation: validationDefault(
                            ['required'],
                            'recoger saldo'
                        ),
                    },
                    {
                        name: 'tipo_garantia',
                        testid: 'ApprovalCertificateGuaranteeTypeInput',
                        label: 'Garantía',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.TIPO_GARANTIAS.value,
                        validation: validationDefault(['required'], 'garantía'),
                    },
                    {
                        name: 'dia_de_pago',
                        testid: 'ApprovalCertificatePaymentDayInput',
                        label: 'Día de pago',
                        disabled: false,
                        type: 'select',
                        url: URL.DIAS_PAGO.value,
                        col: 4,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.PAYDAY.required,
                                },
                            ],

                            'día de pago'
                        ),
                    },
                ],

                fieldsFng: [
                    {
                        name: 'fng_producto',
                        testid: 'ApprovalCertificateFngProductInput',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        url: URL.FNG_PRODUCTO.value,
                        parentDependency: true,
                        childrenDependency: 'fng_porcentaje',
                        validation: validationDefault(
                            ['required'],
                            'fng producto'
                        ),
                    },
                    {
                        name: 'fng_porcentaje',
                        testid: 'ApprovalCertificateFngPercentageInput',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        dependency: 'fng_producto',
                        url: URL.FNG_PORCENTAJE.value, //?fng_producto=4',
                        validation: validationDefault(
                            ['required'],
                            'fng porcentaje'
                        ),
                    },
                    {
                        name: 'fng_calificacion',
                        testid: 'ApprovalCertificateFngRatingInput',
                        label: 'Fng calificación',
                        disabled: true,
                        type: 'select',
                        col: 4,
                        options: genericOptions.calificacion,
                        validation: validationDefault(
                            ['required'],
                            'fng calificación'
                        ),
                    },
                    {
                        name: 'fng_garantia',
                        testid: 'ApprovalCertificateFngGuaranteeInput',
                        label: 'Fng garantía',
                        disabled: true,
                        type: 'integer',
                        col: 4,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.WARRANTY_FNG.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.WARRANTY_FNG.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.WARRANTY_FNG.minLength,
                                },
                            ],

                            'fng garantía'
                        ),
                    },
                ],

                fieldsNoApproved: [
                    {
                        name: 'causal_no_aprobado',
                        testid: 'ApprovalCertificateReasonNotApprovedInput',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.causal_no_aprobado,
                        validation: validationDefault(
                            ['required'],
                            'causal no aprobado'
                        ),
                    },
                ],
            },
            medioDePago: {
                permisions: ['medioDePago:list', 'medioDePago:edit'],
                fields: [
                    {
                        name: 'tipo_pago',
                        testid: 'PaymentMethodPaymentTypeInput',
                        disabled: false,
                        type: 'select',
                        url: '/globals/tipo_pago/?producto={0}',
                        reduxParams: ['credit.productoInformationCredit'],
                        parentDependency: true,
                        childrenDependency: 'detalle_pago',
                        staticCol: 12,
                        validation: validationDefault(
                            ['required'],
                            'tipo de pago'
                        ),
                        notSearchGlobals: true,
                    },
                    {
                        name: 'terceros_cuentas_bancarias',
                        testid: 'PaymentMethodThirdPartyBankAccountsInput',
                        label: 'Número cuenta bancaria',
                        disabled: false,
                        type: 'select',
                        url: '/globals/terceros_cuentas_bancarias/',
                        staticCol: 12,
                        options: [],
                        dependency: 'tercero',
                        validation: validationDefault(['required'], 'cuenta'),
                    },
                    {
                        name: 'valor',
                        testid: 'PaymentMethodValueInput',
                        label: 'Valor a pagar',
                        disabled: false,
                        type: 'price',
                        staticCol: 12,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: 'valor',
                                },
                            ],

                            'valor'
                        ),
                    },
                ],
            },
            insuresCredit: {
                permissions: ['InsuresCredit:list', 'InsuresCredit:edit'],
                fields: [
                    {
                        name: 'tipo_identificacion',
                        label: 'Tipo identificación',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: [
                            {
                                value: 'CC',
                                label: 'CÉDULA',
                            },
                            {
                                value: 'CE',
                                label: 'CÉDULA EXTRANJERÍA',
                            },
                        ],

                        validation: validationDefault(
                            ['required'],
                            'tipo de documento'
                        ),
                    },
                    {
                        name: 'numero_identificacion',
                        label: 'Número de identificación',
                        disabled: false,
                        type: 'integer',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.ID_NUMBER.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.ID_NUMBER.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.ID_NUMBER.minLength,
                                },
                            ],

                            'número de identificación'
                        ),
                    },
                    {
                        name: 'primer_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_NAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_NAME.minLength,
                                },
                            ],

                            'primer nombre'
                        ),
                    },
                    {
                        name: 'segundo_nombre',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_NAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo nombre'
                        ),
                    },
                    {
                        name: 'primer_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.FIRST_SURNAME.required,
                                },
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.FIRST_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.FIRST_SURNAME.minLength,
                                },
                            ],

                            'primer apellido'
                        ),
                    },
                    {
                        name: 'segundo_apellido',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'maxLength',
                                    value: PROPERTIES.SECOND_SURNAME.maxLength,
                                },
                                {
                                    type: 'minLength',
                                    value: PROPERTIES.SECOND_NAME.minLength,
                                },
                            ],

                            'segundo apellido'
                        ),
                    },
                    {
                        name: 'porcentaje_seguro',
                        label: 'Porcentaje seguro (%)',
                        disabled: false,
                        type: 'percentage',
                        col: 3,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'required',
                                    value: PROPERTIES.SAFE_PERCENTAGE.required,
                                },
                                {
                                    type: 'maxValueString',
                                    value: PROPERTIES.SAFE_PERCENTAGE
                                        .maxValueString,
                                },
                            ],

                            'porcentaje seguro'
                        ),
                    },
                    {
                        name: 'parentesco',
                        disabled: false,
                        type: 'select',
                        col: 3,
                        options: genericOptions.tipo_parentesco,
                        validation: validationDefault(
                            ['required'],
                            'parentesco'
                        ),
                    },
                    {
                        name: 'celular',
                        label: 'Celular',
                        disabled: false,
                        type: 'celular',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.CELL_PHONE.regExp,
                                    mesagge:
                                        'El número ingresado no es un número válido',
                                },
                                {
                                    type: 'required',
                                    value: PROPERTIES.CELL_PHONE.required,
                                },
                            ],

                            'celular'
                        ),
                    },
                    {
                        name: 'correo_electronico',
                        label: 'Correo electrónico',
                        disabled: false,
                        type: 'email',
                        col: 6,
                        showTable: true,
                        validation: validationDefaultNew(
                            [
                                {
                                    type: 'pattern',
                                    value: PROPERTIES.EMAIL.regExp,
                                    mesagge:
                                        'El correo electrónico ingresado no es válido',
                                },
                            ],

                            'correo electrónico'
                        ),
                    },
                ],

                fieldsSbs: [
                    {
                        name: 'metodo_construccion',
                        label: 'Método construcción',
                        disabled: false,
                        type: 'select',
                        col: 6,
                        options: [],
                        parentDependency: true,
                        url: URL.METODO_CONSTRUCCION.value,
                        validation: validationDefault(
                            ['required'],
                            'método construcción'
                        ),
                    },
                    {
                        name: 'numero_pisos',
                        label: 'Número de pisos',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefault(
                            ['required'],
                            'número de pisos'
                        ),
                    },
                    {
                        name: 'anios_construccion',
                        label: 'Años construcción',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefault(
                            ['required'],
                            'años construcción'
                        ),
                    },
                    {
                        name: 'numero_sotanos',
                        label: 'Número de sótanos',
                        disabled: false,
                        type: 'integer',
                        col: 6,
                        validation: validationDefault(
                            ['required'],
                            'años construcción'
                        ),
                    },
                ],
            },
            reportsGeneral: {
                fields: [
                    {
                        name: 'tipo_reporte',
                        disabled: false,
                        type: 'select',
                        col: 4,
                        url: '/globals/gestor_reportes/?rol=6',
                        validation: {
                            required: {
                                value: true,
                                message: 'El tipo reporte es obligatorio',
                            },
                        },
                        notSearchGlobals: true,
                    },
                    {
                        name: 'subproductos',
                        label: 'Subproductos',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        url: URL.SUBPRODUCTO.value,
                    },
                    {
                        name: 'oficinas',
                        disabled: false,
                        type: 'select-multiple',
                        col: 4,
                        options: [],
                        url: `/users/{0}/oficinas/`,
                        reduxParams: ['authUser.user'],
                    },
                    {
                        name: 'fecha_desde',
                        label: 'Fecha desde',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha desde es obligatoria',
                            },
                        },
                    },
                    {
                        name: 'fecha_hasta',
                        label: 'Fecha hasta',
                        disabled: false,
                        type: 'date',
                        col: 4,
                        validation: {
                            required: {
                                value: true,
                                message: 'La fecha hasta es obligatoria',
                            },
                        },
                    },
                ],
            },
            runtPreRegistration: {
                fields: [
                    {
                        name: 'numero_identificacion',
                        label: 'Número identificación',
                        disabled: false,
                        type: 'autocomplete',
                        staticCol: 12,
                        options: [],
                        url: '/globals/solicitudes/?oficinas={0}&productos=1,6,4,8',
                        searchSecondParam: true,
                        reduxParams: ['authUser.userOffices'],
                        validation: validationDefault(
                            ['required'],
                            'Número de identificación'
                        ),
                    },
                    {
                        name: 'chasis_vehiculo',
                        label: 'Chasis',
                        disabled: false,
                        type: 'string',
                        staticCol: 12,
                        validation: validationDefault(['required'], 'chasis'),
                    },
                    {
                        name: 'documento_factura',
                        label: 'Factura',
                        disabled: false,
                        type: 'file',
                        staticCol: 12,
                    },
                ],
            },
            BusinessInformationCredit: {
                permisions: [
                    'businessInformationCredit:list',
                    'businessInformationCredit:edit',
                ],

                fields: [
                    {
                        name: 'nombre',
                        testid: 'BusinessNameInput',
                        label: 'Nombre del negocio',
                        disabled: true,
                        type: 'string',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'tipo_negocio',
                        testid: 'BusineTypeInput',
                        label: 'Tipo de negocio',
                        disabled: false,
                        type: 'string',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'antiguedad',
                        testid: 'BusinessAntiquityInput',
                        label: 'Antigüedad de negocio (meses)',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'antiguedad_local',
                        testid: 'BusinessLocalAntiquityInput',
                        label: 'Antigüedad de negocio en local (meses)',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                        showTable: true,
                    },
                    {
                        name: 'empleados_permanentes',
                        testid: 'BusinessPermanentEmployeesInput',
                        label: 'Empleados permanentes',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'empleados_temporales',
                        testid: 'BusinessTemporaryEmployeesInput',
                        label: 'Empleados temporales',
                        disabled: true,
                        type: 'integer',
                        col: 3,
                    },
                    {
                        name: 'telefono',
                        testid: 'ContactPhoneInput',
                        label: 'Teléfono del negocio',
                        disabled: true,
                        type: 'phone',
                        col: 3,
                    },
                    {
                        name: 'celular',
                        testid: 'ContactCellphoneInput',
                        label: 'Celular',
                        disabled: true,
                        type: 'celular',
                        col: 3,
                    },
                    {
                        name: 'sector_economico',
                        testid: 'BusinessEconomicSectorInput',
                        label: 'Sector económico del negocio',
                        disabled: true,
                        type: 'select',
                        col: 3,
                        options: genericOptions.sector_economico,
                    },
                    {
                        name: 'negocio_ciiu',
                        testid: 'BusinessActivityInput',
                        label: 'Actividad del negocio',
                        disabled: true,
                        type: 'autocomplete',
                        col: 6,
                        options: [],
                        url: URL.ACTIVIDAD_ECONOMICA.value,
                    },
                    {
                        name: 'descripcion_actividad',
                        testid: 'BusinessDescInput',
                        label: 'Descripción de la actividad del negocio',
                        disabled: true,
                        type: 'string',
                        col: 3,
                    },
                    {
                        name: 'ciudad_negocio',
                        testid: 'BusinessCityInput',
                        label: 'Ciudad del negocio',
                        disabled: true,
                        type: 'autocomplete-dependency',
                        col: 6,
                        showTable: true,
                        options: [],
                        parentDependency: true,
                        childrenDependency: 'barrio_negocio',
                        url: URL.CIUDADES_POR_DEPARTAMENTO.value,
                        reduxParams: ['globals.departamentos_regional'],
                        searchSecondParam: true,
                    },
                    {
                        name: 'barrio_negocio',
                        testid: 'BusinessNeighborhoodInput',
                        label: 'Barrio del negocio',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        showTable: true,
                        dependency: 'ciudad_negocio',
                        options: [],
                        url: URL.BARRIOS.value,
                    },
                    {
                        name: 'direccion',
                        testid: 'ContactAddressInput',
                        label: 'Dirección del negocio',
                        disabled: true,
                        type: 'addressComplement',
                        staticCol: 12,
                    },
                    {
                        name: 'referencia_ubicacion',
                        testid: 'ContactUbicationInput',
                        label: 'Referencia para ubicación del negocio',
                        disabled: true,
                        type: 'string',
                        col: 6,
                    },
                    {
                        name: 'tipo_local',
                        testid: 'BusinessLocalTypeInput',
                        label: 'Tipo de local',
                        disabled: true,
                        type: 'select',
                        col: 6,
                        options: genericOptions.tipo_local,
                    },

                    {
                        name: 'rut',
                        testid: 'BusinessRutInput',
                        label: 'RUT',
                        disabled: true,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                    },
                    {
                        name: 'camara_comercio',
                        testid: 'BusinessCommerceChamberInput',
                        label: 'Cámara de comercio',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'registra_compras',
                        testid: 'BusinessPurchaseRegistryInput',
                        label: 'Registra compras',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'registra_ventas',
                        testid: 'BusinessSalesRegistryInput',
                        label: 'Registra ventas',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'eps',
                        testid: 'BusinessEpsInput',
                        label: 'EPS',
                        disabled: true,
                        type: 'checkbox',
                        col: 1,
                        typeColumn: 3,
                    },
                    {
                        name: 'sisben',
                        testid: 'BusinessSisbenInput',
                        label: 'SISBEN',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                    {
                        name: 'responsable_iva',
                        testid: 'BusinessVatResponsibleInput',
                        label: 'Responsable de IVA',
                        disabled: true,
                        type: 'checkbox',
                        col: 2,
                        typeColumn: 3,
                    },
                ],

                defaultValues: {
                    tipo_negocio: 'venta de papa',
                    nombre: 'papaMania',
                    antiguedad: 8,
                    antiguedad_local: 5,
                    descripcion_actividad: 'venta de papa',
                    telefono: '7230000',
                    celular: '3164907501',
                    direccion: 'calle  8norte  13a  45',
                    barrio: 'pruebas',
                    referencia_ubicacion: 'en la esquina cruza',
                    sector_economico: 0,
                    tipo_local: 0,
                    empleados_permanentes: 1,
                    empleados_temporales: 1,
                },
            },
        },
    },
};

export default Rules;
